import React, { Component } from "react";
import PropTypes from "prop-types";

import { DarkScreenMask, ImagePicker } from "../..";
import LogoColorPicker from "./LogoColorPicker";
import plus from "../../assets/imgs/plus.png";
import ImageTools from "../../utils/imageTools";
import "./ScoreboardTeamEdit.scss";

class ScoreboardTeamEdit extends Component {
  static propTypes = {
    color: PropTypes.string,
    handleColorChange: PropTypes.func,
    handleImageSave: PropTypes.func,
    handleNameChange: PropTypes.func,
    isHomeTeam: PropTypes.bool,
    logo: PropTypes.string,
    placeholder: PropTypes.string,
    name: PropTypes.string,
    onRemoveTeamColorAndImage: PropTypes.func
  }

  static defaultProps = {
    color: "",
    handleColorChange: ()=> {},
    handleImageSave: ()=> {},
    handleNameChange: ()=> {},
    isHomeTeam: false,
    logo: "",
    name: "",
    placeholder: "Team Name",
    onRemoveTeamColorAndImage: ()=> {}
  }


  state = {
    shouldDisplayModal: false,
    teamColor: "",
    shouldDisplayCropper: false,
    pickerImage: "",
    shouldDisplayLogo: true
  }

  componentDidMount() {
    const { color } = this.props;
    this.setState({
      teamColor: color,
      shouldDisplayLogo: !color
    });
  }

  componentDidUpdate(prevProps) {
    const { color } = this.props;
    if (color !== prevProps.color) {
      this.setState({
        teamColor: color,
        shouldDisplayLogo: !color
      })
    }
  }

  showModal = ()=> {
    this.setState({
      shouldDisplayModal: true
    })
  }

  handleChangeColor = color => {
    const { handleColorChange } = this.props;
    this.setState({
      teamColor: color,
      shouldDisplayModal: !color,
      shouldDisplayLogo: false
    });
    handleColorChange(color);
  }

  handleChangeLogo = async event => {
    if (!event || !event.target.files.length) {
      return;
    }

    const eventCopy = { ...event };
    const reader = new FileReader();

    reader.onloadend = onLoadEvent => {
      this.setState(prevState => ({
        ...prevState,
        shouldDisplayCropper: true,
        pickerImage: onLoadEvent.target.result
      }));
    };
    ImageTools.resize(eventCopy.target.files[0], compressed => {
      reader.readAsDataURL(compressed);
    });
  };

  handleCancelImageCropper = ()=> {
    this.setState({
      shouldDisplayCropper: false,
      pickerImage: ""
    });
  }

  handleSaveImage = image => {
    const { handleImageSave } = this.props;
    this.setState({
      shouldDisplayCropper: false,
      shouldDisplayModal: false,
      shouldDisplayLogo: true
    });

    handleImageSave(image);
  }

  handleNameChange = event => {
    const { handleNameChange } = this.props;
    if(event.target.value.length > 15) {
      this.setState({
        showError: true
      });
      return;
    }

    this.setState({
      showError: false
    });

    handleNameChange(event);

  }

  closeModal = ()=> {
    this.setState({
      shouldDisplayModal: false
    });
  }

  handleRemoveTeamColorAndImage = () => {
    const { onRemoveTeamColorAndImage, isHomeTeam } = this.props;
    onRemoveTeamColorAndImage(isHomeTeam);
    this.setState({
      shouldDisplayModal: false,
      teamColor: "",
      shouldDisplayLogo: true
    });
  };

  render () {
    const { logo, name, isHomeTeam, placeholder } = this.props;
    const { shouldDisplayModal, teamColor, shouldDisplayCropper, pickerImage, shouldDisplayLogo, showError } = this.state;

    return (
      <div className="scoreboard-team-edit">
        <div onClick={this.showModal} className="scoreboard-team-edit__image-wrapper" style={{ backgroundColor: teamColor }}>
          {shouldDisplayLogo &&
            <img src={logo || plus} alt="team-logo" style={{ height: logo ? "100%" : "25px" , width: logo ? "100%" : "25px" }}/>
          }
        </div>
        <div className="scoreboard-team-edit__input-container">
          <input
            className="scoreboard-team-edit__input-container__input"
            placeholder={placeholder}
            value={name}
            onChange={this.handleNameChange}
            onKeyUp={e=>e.preventDefault()}
          />
          {showError &&
            <span
              className="scoreboard-team-edit__input-container__error"
            >
              Team name should be less than 15 characters long
            </span>
          }
        </div>
        <DarkScreenMask isVisible={shouldDisplayModal}>
          {shouldDisplayCropper ?
            <ImagePicker
              img={pickerImage}
              aspectRation={1}
              cropperStyle={{ height: 200, width: 200 }}
              handleCancel={this.handleCancelImageCropper}
              handleSave={this.handleSaveImage}
              isRound
            /> :
            <LogoColorPicker
              color={teamColor}
              onChangeColor={this.handleChangeColor}
              onChangeLogo={this.handleChangeLogo}
              onRemoveTeamColorAndImage={this.handleRemoveTeamColorAndImage}
              isHomeTeam={isHomeTeam}
              onBack={this.closeModal}
            />
          }
        </DarkScreenMask>
      </div>
    );
  };
};

export default ScoreboardTeamEdit;
